import React from "react";
import useTrengo from "../../hooks/useTrengo"; // Importeer de useTrengo hook

const ChatAndWhatsAppButtons = () => {
  const trengoLoaded = useTrengo(); // Gebruik de hook om te controleren of Trengo is geladen

  const handleChatClick = () => {
    if (trengoLoaded) {
      try {
        console.log("Probeer chat te openen...");
        const widget = document.querySelector('#trengo-web-widget');
        if (widget) {
          widget.style.visibility = 'visible'; // Maak de widget zichtbaar
        }
        window.Trengo.sound = false; // Zet het geluid uit
        window.Trengo.Api.Widget.render(); // Render de widget indien nodig
        window.Trengo.Api.Widget.open("chat"); // Open de chat
      } catch (error) {
        console.error("Fout bij het openen van de chat via Trengo:", error);
      }
    }
  };

  const handleWhatsAppClick = () => {
    if (trengoLoaded) {
      try {
        console.log("Probeer WhatsApp te openen...");
        const widget = document.querySelector('#trengo-web-widget');
        if (widget) {
          widget.style.visibility = 'visible'; // Maak de widget zichtbaar
        }
        window.Trengo.sound = false; // Zet het geluid uit
        window.Trengo.Api.Widget.render(); // Render de widget indien nodig
        window.Trengo.Api.Widget.open("whatsapp"); // Open WhatsApp
      } catch (error) {
        console.error("Fout bij het openen van WhatsApp via Trengo:", error);
      }
    }
  };

  return (
    <div>
      {/* Chat Button */}
      <a 
        onClick={handleChatClick}
        disabled={!trengoLoaded} // Deactiveer de knop totdat Trengo is geladen
        className="mx-2 hover:cursor-pointer"
      >
        Keuzehulp
      </a>

      {/* WhatsApp Button */}
      <a 
        onClick={handleWhatsAppClick}
        disabled={!trengoLoaded} // Deactiveer de knop totdat Trengo is geladen
        className="mx-2 hover:cursor-pointer"
      >
        WhatsApp
      </a>

      <a href="tel:+31850607810" className="mx-2">
        085-0607810
      </a>
    </div>
  );
};

export default ChatAndWhatsAppButtons;
